import React from 'react';

export const RedClose = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0846 7.74047L14.2621 6.91797L11.0013 10.1788L7.74047 6.91797L6.91797 7.74047L10.1788 11.0013L6.91797 14.2621L7.74047 15.0846L11.0013 11.8238L14.2621 15.0846L15.0846 14.2621L11.8238 11.0013L15.0846 7.74047Z"
        fill="#D44040"
      />
    </svg>
  );
};
